module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAXCAYAAAA7kX6CAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABiSURBVHgB7dLRCcAgDARQR+gG7SYdpd3IETpSR3AERzgTuA/BDz3/BA/u85FAEgC81mxN1ieMhqDOGOY0yJirYuNVsd/96MEL7Wd5zhkUZ9C3UQ8R/jIizDIijDKq8O1VTAHv8yHRqmW6qQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment/arrowForwardWhite@2x.png
// module id = 1827
// module chunks = 0